import { UserDao } from '@/dao';
import type { MenuItem } from '@/objects';
import type { ManagerUser } from '@/objects/generated';
import { onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

export type AccessLevel = 'superadmin' | 'user';

let checkcount = 0;
//The interval id so we can clear it when the component is unmounted.
let loginIntervalCheck: number | null = null;
const loginIntervalCheckTime = 60000;

// The user that is currently logged in.
let _user: ManagerUser | null = null;

export const useAccessValidator = () => {
    /**
     * Set the user in the access validator.
     * @param user
     */
    const SetUser = (user: ManagerUser) => {
        _user = user;

        clearLoginInterval();
        loginIntervalCheck = window.setInterval(checkUserLoggedIn, loginIntervalCheckTime);
    };

    /**
     * This function checks if the user is logged in.
     * If it is not logged in, it will redirect to the login page.
     */
    const checkUserLoggedIn = async () => {
        try {
            checkcount++;
            const user = await UserDao.User();

            if (user == null) {
                throw new Error('user.notloggedin');
            }

            checkcount = 0;
        } catch (e) {
            if (checkcount > 3) {
                checkcount = 0;
                console.error('User is not logged in. We should redirect to login page with an error message.');

                clearLoginInterval();

                document.location.reload();
            }
        }
    };

    /**
     * Check if the user role has access to the menu item.
     * @param mi The menu item to check access for.
     * @returns
     */
    const CheckMenuAccess = (mi: MenuItem) => {
        if (_user == null || mi.roles == undefined || mi.roles.length == 0) {
            return true;
        }
        if (mi.roles.includes('superadmin') && _user?.IsSuperAdmin) {
            return true;
        }
        return false;
    };

    const CheckViewAccess = () => {
        const route = useRoute();

        if (route.matched.length === 0) return true;

        // We get all the roles that are defined on the route
        const roles = (route.matched[0]?.props['default'] as any)?.roles as string[] | undefined;

        if (!roles) return true;

        if (_user === null) {
            console.error('User is not logged in.');
            return false;
        }
        if (roles.includes('superadmin') && !_user.IsSuperAdmin) {
            console.error('User does not have the required role.');
            return false;
        }

        return true;
    };

    const clearLoginInterval = () => (loginIntervalCheck != null ? clearInterval(loginIntervalCheck) : null);

    return { CheckViewAccess, CheckMenuAccess, SetUser };
};
